import { ProcessosAtividadesDTO } from "../../../../viewmodel/CronogramaViewModel";
import { EventoCalendario } from "../EventoCalendario";

export function converterParaEventosCalendario(atividadesOutrasDTO: ProcessosAtividadesDTO[]): EventoCalendario[] {
    let eventosCalendario: EventoCalendario[] = [];

    atividadesOutrasDTO.forEach(processoAtividade => {
        const eventos = processoAtividade.atividades.map(atividade => {
            const dataHoraInicio = new Date(`${atividade.data}T${atividade.hora}`);
            const dataHoraFim = new Date(dataHoraInicio.getTime() + 60 * 60 * 1000);

            return {
                ...atividade,
                title: atividade.descricao,
                start: dataHoraInicio,
                end: dataHoraFim,
                color: processoAtividade.cor, 
                allDay: false, 
                isVisible: true 
            };
        });

        eventosCalendario = [...eventosCalendario, ...eventos];
    });

    return eventosCalendario;
}



